import {Controller} from "@mecatran-components/controller"
import {DomUtils} from "../services/utils/index.web.mjs";
import {StopListButton} from "../components/stoplistbutton.component.mjs";
import {SearchBar} from "SRC/components/searchbar.component.mjs";
import {StopTag} from "../components/stoptag.component.mjs";
import {SuggestionList, SuggestionListOptions} from "../components/suggestionlist.component.mjs"
import {StopList, StopListOptions } from "../components/stoplist.component.mjs";
import * as sources from "SRC/services/datasources/factorysources.mjs";

      

/**
 * view - Component [mandatory]
 * type - string ('home','school')  [mandatory]
 * schoolId - Stop - parameter required only if type = stop 
 */
export class StopSelector extends Controller{
    constructor(view, type, schoolId, mapComponent){
        if (!(view && type)) throw new Error('StopSelector. Parameters are mandatory')
        if ((type === 'home')&& !schoolId) throw new Error('StopSelector. SchoolId is required for type "home"')
        super(view);
        var  _type = type,
             _schoolId = schoolId,
             _school,
             _mapComponent = mapComponent
        ;

        /* ========================================== */
        /* public
        /* ========================================== */

        Object.defineProperty(this,'type',{
            set : function(t){ _type = t },
            get : function(){ return _type }
        })

        /*
        Object.defineProperty(this,'school',{
            get : function(){ return _school }
        });
        */

        
        Object.defineProperty(this,'mapComponent',{
            /* set : function(mc){ _mapComponent = mc }, */
            get : function(){ return _mapComponent }
        });
        

        /* ========================================== */
        /* private
        /* ========================================== */



        this.updateItineraryIndex(_schoolId);
        this.initStopSelector(type);

    }

    displayAllStops(){
        var type = this.type;
        //var mapComponent = this.mapComponent;
        var mapComponent = this.getComponent(this.componentMapName)
        /*
        var stopSource;
        if (type === 'home') stopSource = sources.homeSource;
        if (type === 'school') stopSource = sources.schoolSource;
        */
        var stopSource = this.getStopSource();
        stopSource.clearCache();
        mapComponent.setDataSource( stopSource);
        mapComponent.displayAllStops();
        this.view.hide(this.bodyPanelSelector); // tmp 
    }

    updateItineraryIndex(schoolId){
        var fileName = this.getFilename(schoolId);
        var itineraryIndexSource = sources.itineraryIndexSource;
        itineraryIndexSource.updateFilename(fileName);
    }

    getFilename(schoolId){
        // sources.destinationIndex.getFilename(schoolId);
        return `${schoolId}.json`;
    }

    getStopSource(){
        var stopSource;
        switch(this.type){
            case 'school':
                stopSource = sources.schoolSource;
                break;
            case 'home':
                stopSource = sources.homeSource;
                stopSource.clearCache();
                break;
        }
        return stopSource;
    }

    getSchoolStopPromise(){
        return sources.itineraryIndexSource.get()
            .then((itineraryIndex)=>itineraryIndex.getDestination());
    }

    closeAllLists(){
        this.removeFromView(this.stopSuggestionListName);
        this.view.hide(this.bodyPanelSelector); // tmp 
    }

    appendLayoutToView(){
        this.layout = this.createLayout();
        var viewNode = this.view.getDomNode();
        //var selector = "#lateral-panel-bloc";
        var selector 
        var contentNode = viewNode.querySelector(selector);
        contentNode.appendChild(this.layout);
    }

    removeLayoutFromView(){
        // this.layout.remove(); 
        // should remove the content of header-body 
        DomUtils.removeChilds('#header-panel');
        DomUtils.removeChilds('#footer-panel');
    }

    leaveView(){
        var map = this.getComponent(this.componentMapName);
        map.hide();       
        this.clearEventDefineListener(this.componentMapName); // TMP should not manage the listeners 
        this.removeFromView(this.stopSuggestionListName); // replace by closeAll ?
        this.removeFromView(this.searchBarName);
        this.removeFromView(this.stopTagName)
        this.removeFromView(this.stopListName)
        this.removeLayoutFromView();
    }

    notifySchoolSelected(stop){
        this.leaveView();   
        var controllerManager = this.controllerManager;
        if (controllerManager) controllerManager.onSchoolSelected(stop);    

    }

    /*
    notifyStopTagSelected(id, stop){
        this.leaveView(); 
        var homeStop;
        var controllerManager = this.controllerManager;
        if (this.type === 'school'){
            if (!stop.isDestination) throw new Error('notifyStopTagSelected:: expect isDestination is true');
            this.updateItineraryIndex(stop.getId());
            homeStop = undefined; 
        }
        if (this.type === 'home'){
            homeStop = stop; 
        }
        if (controllerManager){
            this.getSchoolStopPromise().then((schoolStop)=>{
                //controllerManager.onBackButton(this, type, schoolStop );// Improve use events or a callback to avoid this dependency  
                controllerManager.onStopTagSelected(id, schoolStop, homeStop );
            })
            
        }
    }
    */
    notifyStopTagSelected(id,stop){
        this.leaveView(); 
        var controllerManager = this.controllerManager;
        var homeStop;
        var schoolStop = stop;
        if (controllerManager){
            if (stop.isDestination){
                controllerManager.onStopTagSelected(id, schoolStop);
                return;
            } else {
                homeStop = stop;
                this.getSchoolStopPromise().then((schoolStop)=>{
                    //controllerManager.onBackButton(this, type, schoolStop );// Improve use events or a callback to avoid this dependency  
                    controllerManager.onStopTagSelected(id, schoolStop, homeStop );
                })  
            }
        }
    }

    notifyBackEvent(){
        this.leaveView(); 
        var type = this.type; 
        var controllerManager = this.controllerManager;
        if (controllerManager){
            this.getSchoolStopPromise().then((schoolStop)=>{
                controllerManager.onBackButton(this, type, schoolStop );// Improve use events or a callback to avoid this dependency  
            })
        }
    }

    onBackEvent(event){  
        this.notifyBackEvent();
    }

    onStopListButtonClickEvent(event){
        this.removeFromView(this.stopTagName) // use view.clearFooter
        this.removeFromView(this.stopListButtonName)
        this.addToView(this.stopListName, this.footerPanelSelector);        
    }


    onSearchBoxClickEvent(event){
        var map = this.getComponent(this.componentMapName);
        map.hide();
        this.addToView(this.stopSuggestionListName, this.bodyPanelSelector);
        this.view.show(this.bodyPanelSelector); // tmp 
    }

    onSearchBoxInputEvent(event){
        var query = event.detail.query;
        var stopSuggestionList = this.createComponent(this.stopSuggestionListName);
        var stopSource = stopSuggestionList.getDataSource();
        stopSource.setQuery(query)
        this.addToView(this.stopSuggestionListName, this.bodyPanelSelector); 
    }

    onSuggestionListSelectEvent(event){
        var stop = event.detail.data; 
        var dataSetName = event.detail.datasetName;
        if (this.type === 'school'){
            this.getComponent(this.componentMapName).clearMap();
            /*
            this.removeFromView(this.stopSuggestionListName); // replace by closeAll ?
            this.removeFromView(this.searchBoxName);
            */
            this.leaveView();
            this.notifySchoolSelected(stop);
        } 
        else {
            /* an home station has been selected:
                - update the map with only the selected stop 
                - remove the stoplist 
                - display the stop tag
            */
            this.removeFromView(this.stopListName);
            this.createComponent(this.stopTagName,stop);
            this.addToView(this.stopTagName, this.footerPanelSelector);
            this.view.hide(this.bodyPanelSelector);
        }
    }

    onStopListSelectEvent(event){
        console.log('event',event)
        var { data, datasetName }= event.detail;
        var stop = data;
        var mapComponent = this.getComponent(this.componentMapName);

        //mapComponent.stopAllMarkersAnimation();

        var mapClient = mapComponent.getMapClient();
        var marker = mapClient.getMarker(stop);
        console.log('marker',marker)
        // marker.setAnimation(google.maps.Animation.BOUNCE);

        // center the map to the stop or marker
        
        var map = mapClient.getGoogleMaps().getMap();
        map.panTo(marker.getPosition());

        var stopList = this.getComponent(this.stopListName);
        stopList.deactivateAll();
    }

    onStopListTagEvent(event){
        console.log(event)
        var {id, stop } = event.detail; 
        this.notifyStopTagSelected(id, stop);
    }

    onStopListMousedown(event){
        console.log('event mousedown:', event.button);
        var {id, stop } = event.detail; 
        var mapComponent = this.getComponent(this.componentMapName);
        var mapClient = mapComponent.getMapClient();
        var factor = 2;
        mapClient.updateIconSize(stop, factor);
    }

    onStopListMouseup(event){
        console.log('event mouseup:', event.button);   
        var {id, stop } = event.detail; 
        var mapComponent = this.getComponent(this.componentMapName);
        var mapClient = mapComponent.getMapClient();
        var factor = 0.5;
        mapClient.updateIconSize(stop, factor);     
    }

    onStopTagSelectEvent(event){
        console.log(event)
        var {id, stop } = event.detail; 
        this.removeFromView(this.stopTagName);
        this.removeFromView(this.searchBoxName);
        this.notifyStopTagSelected(id, stop);
    }

    onMapClickEvent(event){
        console.log('map click event', event, 'this.type', this.type)
        var stop = event.detail.data;
        var stopList = this.getComponent(this.stopListName);
        var findfn = stopList.findComponent(stop)
        stopList.scrollTo(findfn);
        stopList.deactivateAll();
        stopList.activate(findfn);

    }

    /*
    createLayout(){
        var container = this.createElement('div','stop-selector',['stop-selector']);
        var backButton = this.createElement('div','back-button')
        var od = this.createElement('div','search-box');
        var suggestionList = this.createElement('div','suggestion-list');
        var stopTag = this.createElement('div','stop-tag')
        container.appendChild(backButton);
        container.appendChild(od);
        container.appendChild(stopTag);
        container.appendChild(suggestionList);
        return container;
    }
    */

    createLayout(){
        var backButton = this.createElement('div','back-button')
        var searchBox = this.createElement('div','search-box');        
    }

    createElement(type, id,classList= []){
        var el = document.createElement(type);
        el.setAttribute('id',id);
        classList.forEach(klass => el.classList.add(klass));
        return el; 
    }


    createViewListener(){
        var viewNode = this.view.getDomNode();
        viewNode.addEventListener('click',(event)=>{
            console.log('handler view listener')
            var map = this.getComponent(this.componentMapName);
            map.show();
            this.closeAllLists();
        });
    }

    createMapComponent(){
        var mapComponent = this.mapComponent;
        var stopSource = this.getStopSource();
        mapComponent.setDataSource(stopSource);
        return mapComponent;  // TMP (component shared among controllers) 
    }



    createStopListButton(){
        return new StopListButton();
    }

    createSuggestionList(){
        var stopSource = this.getStopSource();
        stopSource.clearCache();
        /*
        switch(type){
            case 'school':
                stopSource = sources.schoolSource;
                break;
            case 'home':
                stopSource = sources.homeSource;
                stopSource.clearCache();
                break;
        }
        */
        var suggestionListOptions = new SuggestionListOptions(stopSource);
        var stopSuggestionList = new SuggestionList(suggestionListOptions);
        stopSuggestionList.build();
        return stopSuggestionList;

    }

    createStopList(){
        var stopSource = this.getStopSource();
        stopSource.clearCache();

        var stopListOptions = new StopListOptions(stopSource);
        var stopList = new StopList(stopListOptions);
        stopList.build();
        return stopList;
    }

    /*
    createSearchBoxComponent(type){
        var placeholder;
        switch(type){
            case 'school':
                placeholder = "Choisir un établissement";
                break; 
            case 'home':
                placeholder = "Choisir un arrêt attaché à l'établissement"
        }
        var inputOptions = { 
            placeholder ,
            classList : ['search']
        }
        var domOptions = {
            id: 'test1',
            classList : ['search-box']
        }
        var clearButtonUrl = './assets/cross.svg'
        var options = { domOptions , inputOptions, clearButtonUrl }
        var searchBox = new SearchBox(options);
        return searchBox;
    }
    */

    createStopTag(stop){
        return new StopTag(stop);
    }

    createSearchBar(type){
        return new SearchBar(type);
    }

    registerSearchBar(){
        var name = "searchBar";
        this.searchBarName = name;
        this.register(name, this.createSearchBar);
        this.registerEventDefineListener(name,['inputEvent',()=>true,this.onSearchBoxInputEvent.bind(this)]);
        this.registerEventDefineListener(name,['click',()=>true,this.onSearchBoxClickEvent.bind(this)]);
        this.registerEventDefineListener(name,['backEvent',()=>true,this.onBackEvent.bind(this)]);
    }



    /*
    registerBackButton(){
        var name = 'backbutton';
        this.backButtonName = name;
        this.register(name, this.createBackButton);
        this.registerEventDefineListener(name,['backEvent',()=>true,this.onBackEvent.bind(this)]);
        this.createComponent(name);
    }
    */

    registerStopListButton(){
        var name = "stopListButton";
        this.stopListButtonName = name;
        this.register(name, this.createStopListButton);
        this.registerEventDefineListener(name,['stopListEvent',()=>true,this.onStopListButtonClickEvent.bind(this)]);
        this.createComponent(name);
    }


    registerSearchBox(){
        var name = 'searchbox';
        this.searchBoxName = name;
        this.register(name, this.createSearchBoxComponent);
        this.registerEventDefineListener(name,['inputEvent',()=>true,this.onSearchBoxInputEvent.bind(this)]);
        this.registerEventDefineListener(name,['click',()=>true,this.onSearchBoxClickEvent.bind(this)]);
        //this.createComponent(name);
    }


    registerStopSuggestionList(){
        var name = 'stopsuggestionlist';
        this.stopSuggestionListName = name;
        this.register(name, this.createSuggestionList);
        this.registerEventDefineListener(name,['selectEvent',()=>true,this.onSuggestionListSelectEvent.bind(this)]);
        this.createComponent(name);
    }

    registerStopList(){
        var name = 'stopList';
        this.stopListName = name;
        this.register(name, this.createStopList.bind(this));
        this.registerEventDefineListener(name,['selectEvent',()=>true,this.onStopListSelectEvent.bind(this)]);
        this.registerEventDefineListener(name,['tagEvent',()=>true,this.onStopListTagEvent.bind(this)]);
        this.registerEventDefineListener(name,['tagMousedownEvent',()=>true, this.onStopListMousedown.bind(this)]);
        this.registerEventDefineListener(name,['tagMouseupEvent',()=>true, this.onStopListMouseup.bind(this)]);
        this.createComponent(name);
    }

    registerStopTag(){
        var name = 'stopTag';
        this.stopTagName = name;
        this.register(name,this.createStopTag.bind(this));
        this.registerEventDefineListener(name,['tagEvent',()=>true,this.onStopListTagEvent.bind(this)]);
    }

    registerMapComponent(){
        var name = 'mapComponent';
        this.componentMapName = name;
        this.register(name, this.createMapComponent.bind(this));
        this.registerEventDefineListener(name,['clickEvent',()=>true, this.onMapClickEvent.bind(this)])
        this.createComponent(this.componentMapName);
    }


    initStopSelector(type){
        this.type = type;

        // temp

        // temp
        this.headerPanelSelector = "#header-panel"; 
        this.bodyPanelSelector = "#body-panel"
        this.footerPanelSelector =  "#footer-panel"; 


        //this.appendLayoutToView();

        this.view.hide(this.bodyPanelSelector); // tmp 
        this.view.show(this.footerPanelSelector);

        this.createViewListener();
        this.registerMapComponent();
        //this.registerBackButton();
        this.registerStopListButton();
        //this.registerSearchBox();
        this.registerSearchBar();
        this.registerStopSuggestionList();
        this.registerStopList();
        this.registerStopTag();

        var map = this.getComponent(this.componentMapName);
        map.show();

        this.createComponent(this.searchBarName, type);
        this.addToView(this.searchBarName, this.headerPanelSelector);
        
        if (type==='school'){

            //this.addToView(this.stopListName, this.footerPanelSelector);
            //this.displayAllStops();           
        }
        if (type==='home'){
            /*
            this.addToView(this.backButtonName, this.headerPanelSelector);
            this.createComponent(this.searchBoxName, 'home')
            this.addToView(this.searchBoxName, this.headerPanelSelector );
            */
            /*
            this.createComponent(this.stopTagName,stop);
            this.addToView(this.stopTagName, this.bodyPanelSelector);
            this.view.show(this.bodyPanelSelector);
            */
            
            this.getSchoolStopPromise().then((school)=>{

                this.addToView(this.stopListName, this.footerPanelSelector); 
                /*
                this.createComponent(this.stopTagName, school);
                this.addToView(this.stopTagName, this.footerPanelSelector);
                this.addToView(this.stopListButtonName, this.footerPanelSelector);
                */
                /*
                this.addToView(this.stopListName, this.footerPanelSelector);
                */
                this.displayAllStops();
            })
        } 
 
    }


}

